import serverInterface from 'server-interface';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

class MarketProductsManager {

  constructor(application) {

    this.initialized = false;
    this.loaded = false;
    this.collection = [];

    this.application = application;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.initialized = true;

  }

  tryAdd(item) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', item._id);

    if (itemIndex !== -1) {
      return;
    }

    this.collection.push(item);

  }

  tryRemove(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    if (itemIndex === -1) {
      return;
    }

    this.collection.splice(itemIndex, 1);

  }

  registerEventHandlers() {

  }

  async loadAll() {

    if (this.loaded === true) {
      return;
    }

    this.collection = await serverInterface.startup.marketProducts.getActiveMarketProductsByQueryOptions({ filterOptions: { name: '' } });

    this.loaded = true;

  }

  getAll() {

    return structuredClone(this.collection);

  }

  isExistsById(itemId) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', itemId);

    return itemIndex !== -1;

  }

  async create(payload) {

    const item = await serverInterface.startup.marketProducts.createStandardProduct(payload);

    this.tryAdd(item);

    return item;

  }

  async getById(id) {

    const itemIndex = findIndexByPropertyValue(this.collection, '_id', id);

    if (itemIndex === -1) {
      return null;
    }

    return structuredClone(this.collection[itemIndex]);

  }

  async update(id, payload) {

    const item = await serverInterface.startup.marketProducts.updateMarketProductById(id, payload);

    this.tryRemove(id);

    this.tryAdd(item);

    return item;

  }

  async copy(id) {

    const item = await serverInterface.startup.marketProducts.copyProduct(id);

    return item;

  }

  async setStatus(id, status) {

    const updated = await serverInterface.startup.marketProducts.setMarketProductStatusById(id, status);

    const item = await this.getById(id);

    if (item === null) {
      return updated;
    }

    item.status = status;

    this.tryRemove(id);

    this.tryAdd(item);

    return updated;

  }

  async delete(itemId) {

    await serverInterface.startup.users.collection.deleteById(itemId);

    this.tryRemove(itemId);

  }

}

export default MarketProductsManager;